module.exports = __webpack_public_path__ + "img/04.3d392f28.jpg";